import {
    Course,
    CourseDetail,
    CourseStep,
    DownloadedCourseDetail,
    ReceivedGift,
} from "JS/Models";
import { useDownloadedCourses } from "../DownloadCourses";
import { cloneDeep } from "lodash-es";
import { config } from "JS/Config";

export const useSyncOfflineCourses = () => {
    const { downloadedCourses, userDownloadedCourses, setDownloadedCourses } =
        useDownloadedCourses();

    const syncOfflineCourses = (
        allCourses: (Course | ReceivedGift)[],
        contentType: "GiftCourse" | "Course",
    ) => {
        let tempDownloadedCourses = cloneDeep(downloadedCourses);
        const mappedData = allCourses?.filter((x) =>
            userDownloadedCourses.some((z) => z.nid === x.nid),
        );

        mappedData?.forEach((x) => {
            let dataIndex = tempDownloadedCourses?.findIndex(
                (z) => z.nid === x.nid && z.memberId === config.user.memberId,
            );

            if (dataIndex !== -1) {
                tempDownloadedCourses[dataIndex] = {
                    ...tempDownloadedCourses[dataIndex],
                    memberId: config.user.memberId,
                    releaseDate: (x as Course)?.release_date || "",
                    isPurchased:
                        contentType === "GiftCourse"
                            ? tempDownloadedCourses[dataIndex].isPurchased
                            : (x as Course).is_purchased,
                    sku_id: x.sku_id,
                    title: x.title,
                    description: x.description,
                    nid: x.nid,
                    content_type: contentType,
                    steps: tempDownloadedCourses[dataIndex].steps,
                } as DownloadedCourseDetail;
            }
        });

        setDownloadedCourses(tempDownloadedCourses);
    };

    const syncOfflineCourseSteps = (crsDetail: CourseDetail) => {
        let tempDownloadedCourses = cloneDeep(downloadedCourses);

        let courseIndex = tempDownloadedCourses?.findIndex(
            (x) =>
                x.nid === crsDetail?.nid && x.memberId === config.user.memberId,
        );
        if (courseIndex !== -1) {
            if (crsDetail?.steps?.length) {
                const tempCourseStep: CourseStep[] = crsDetail.steps.map(
                    (x) => {
                        return {
                            ...x,
                            isDownloaded: tempDownloadedCourses[
                                courseIndex
                            ]?.steps?.find((z) => z.nid === x.nid)
                                ? tempDownloadedCourses[
                                      courseIndex
                                  ]?.steps.find((z) => z.nid === x.nid)
                                      ?.isDownloaded
                                : x.content_type === "quiz",
                        };
                    },
                );
                tempDownloadedCourses[courseIndex].steps = tempCourseStep;
            } else {
                tempDownloadedCourses[courseIndex].steps = [];
            }
        }
        setDownloadedCourses(tempDownloadedCourses);
    };

    return {
        syncOfflineCourses,
        syncOfflineCourseSteps,
    };
};
